<template>
<v-container>
      <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <CompanyContent></CompanyContent>
 </v-container>
</template>

<script>
// 会社概要
import CompanyContent from '../components/Company/CompanyContent'

export default {
  name: 'Company',
  components: {
    CompanyContent
  }
}
</script>
<script>
import CompanyContent from '../components/Company/CompanyContent'
export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
     {
        name: '会社情報',
        href: 'Company'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    CompanyContent
  }
}
</script>
